import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid
} from '@mui/material';
import { Address } from '@/types';
import { useI18n } from '@/hooks/useI18n';

interface AddressSectionProps {
  address: Address;
  onAddressChange: (address: Address) => void;
}

const AddressSection: React.FC<AddressSectionProps> = ({
  address,
  onAddressChange
}) => {
  const { t } = useI18n();
  
  const handleFieldChange = (field: keyof Address, value: string) => {
    onAddressChange({ ...address, [field]: value });
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>🏠 {t('common.address')}</Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label={t('address.street')}
            value={address.street}
            onChange={(e) => handleFieldChange('street', e.target.value)}
            required
            placeholder={t('address.streetPlaceholder')}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label={t('address.postalCode')}
            value={address.postalCode}
            onChange={(e) => handleFieldChange('postalCode', e.target.value)}
            required
            placeholder={t('address.postalCodePlaceholder')}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label={t('address.city')}
            value={address.city}
            onChange={(e) => handleFieldChange('city', e.target.value)}
            required
            placeholder={t('address.cityPlaceholder')}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            fullWidth
            label={t('address.country')}
            value={address.country}
            onChange={(e) => handleFieldChange('country', e.target.value)}
            required
            placeholder={t('address.countryPlaceholder')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddressSection;
